const enUs = {
    values: {}
}

export default enUs
